var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_3532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2105 2.39551L6.91406 12.959L24.7206 23.9166L43.0171 13.3532L25.2105 2.39551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42969 12.9512L25.2155 2.10516L43.5033 13.359L24.7175 24.205L6.42969 12.9512ZM7.40032 12.9648L24.7256 23.6263L42.5327 13.3453L25.2074 2.68386L7.40032 12.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76263 14.2012L23.404 24.9639L4.76263 35.7265L4.76263 14.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9555 47.6055L42.252 37.042L24.4454 26.0843L6.14895 36.6478L23.9555 47.6055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7383 37.0488L23.9524 47.8948L5.66465 36.641L24.4505 25.795L42.7383 37.0488ZM41.7677 37.0352L24.4424 26.3737L6.63528 36.6547L23.9606 47.3161L41.7677 37.0352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4053 35.7993L25.7639 25.0366L44.4053 14.274L44.4053 35.7993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_3532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitan);
export default __webpack_public_path__ + "static/media/titan.b9f88432fdb88072d8056593b1a741c9.svg";
export { ForwardRef as ReactComponent };